import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import { useAuth } from "@/components/auth/Auth";
import { useWaveActivityLogs } from "@/hooks/useWaveActivityLogs";
import { WaveLeaderboardRightSidebarActivityLog } from "./WaveLeaderboardRightSidebarActivityLog";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import { useWaveChatScrollOptional } from "@/contexts/wave/WaveChatScrollContext";
interface WaveLeaderboardRightSidebarActivityLogsProps {
  readonly wave: ApiWave;
}
export const WaveLeaderboardRightSidebarActivityLogs: React.FC<WaveLeaderboardRightSidebarActivityLogsProps> = t0 => {
  const $ = _c(32);
  const {
    wave
  } = t0;
  const waveChatScroll = useWaveChatScrollOptional();
  let t1;
  if ($[0] !== wave.id || $[1] !== waveChatScroll) {
    t1 = serialNo => {
      waveChatScroll?.requestScrollToSerialNo({
        waveId: wave.id,
        serialNo
      });
    };
    $[0] = wave.id;
    $[1] = waveChatScroll;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleDropClick = t1;
  const {
    connectedProfile
  } = useAuth();
  const t2 = connectedProfile?.handle ?? undefined;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["DROP_VOTE_EDIT"];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== wave.id) {
    t4 = {
      waveId: wave.id,
      connectedProfileHandle: t2,
      reverse: false,
      dropId: null,
      logTypes: t3
    };
    $[4] = t2;
    $[5] = wave.id;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    logs,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    isLoading
  } = useWaveActivityLogs(t4);
  let t5;
  if ($[7] !== fetchNextPage || $[8] !== hasNextPage || $[9] !== isFetchingNextPage || $[10] !== isLoading) {
    t5 = () => {
      if (hasNextPage && !isLoading && !isFetchingNextPage) {
        fetchNextPage();
      }
    };
    $[7] = fetchNextPage;
    $[8] = hasNextPage;
    $[9] = isFetchingNextPage;
    $[10] = isLoading;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const intersectionElementRef = useIntersectionObserver(t5);
  if (logs.length === 0 && !isLoading) {
    let t6;
    let t7;
    let t8;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className="tw-absolute tw-inset-0 tw-animate-[spin_4s_linear_infinite] tw-rounded-full tw-bg-gradient-to-br tw-from-primary-400/20 tw-via-indigo-500/10 tw-to-iron-800/10 desktop-hover:group-hover:tw-from-primary-400/30" />;
      t7 = <div className="tw-absolute tw-inset-0 tw-animate-[spin_5s_linear_infinite] tw-rounded-full tw-bg-gradient-to-tr tw-from-iron-800/10 tw-via-indigo-500/10 tw-to-primary-400/20 desktop-hover:group-hover:tw-to-primary-400/30" />;
      t8 = <div className="tw-bg-gradient-radial tw-absolute tw-inset-0 tw-animate-pulse tw-from-primary-300/5 tw-to-transparent" />;
      $[12] = t6;
      $[13] = t7;
      $[14] = t8;
    } else {
      t6 = $[12];
      t7 = $[13];
      t8 = $[14];
    }
    let t9;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <div className="tw-group tw-relative">{t6}{t7}{t8}<svg className="tw-relative tw-size-10 tw-flex-shrink-0 tw-text-white/60" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M22.7 13.5L20.7005 11.5L18.7 13.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C15.3019 3 18.1885 4.77814 19.7545 7.42909M12 7V12L15 14" /></svg></div>;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    let t10;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <div className="tw-mt-10 tw-flex tw-flex-col tw-items-center tw-justify-center tw-space-y-6 tw-text-iron-400">{t9}<div className="tw-flex tw-flex-col tw-items-center tw-gap-y-2"><span className="tw-bg-gradient-to-br tw-from-iron-200 tw-via-iron-300 tw-to-iron-400 tw-bg-clip-text tw-text-lg tw-font-semibold tw-tracking-tight tw-text-transparent">Be the First to Make a Vote</span><p className="tw-mb-0 tw-max-w-64 tw-text-center tw-text-sm tw-text-iron-500">Vote on drops to see activity updates appear here in real-time.</p></div></div>;
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    return t10;
  }
  let t6;
  if ($[17] !== handleDropClick || $[18] !== logs || $[19] !== wave.voting) {
    let t7;
    if ($[21] !== handleDropClick || $[22] !== wave.voting) {
      t7 = log => <WaveLeaderboardRightSidebarActivityLog key={log.id} log={log} creditType={wave.voting.credit_type} onDropClick={() => handleDropClick(log.contents.drop.serial_no)} />;
      $[21] = handleDropClick;
      $[22] = wave.voting;
      $[23] = t7;
    } else {
      t7 = $[23];
    }
    t6 = logs.map(t7);
    $[17] = handleDropClick;
    $[18] = logs;
    $[19] = wave.voting;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[24] !== isFetchingNextPage) {
    t7 = isFetchingNextPage && <div className="tw-h-0.5 tw-w-full tw-overflow-hidden tw-bg-iron-800"><div className="tw-h-full tw-w-full tw-animate-loading-bar tw-bg-indigo-400" /></div>;
    $[24] = isFetchingNextPage;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== intersectionElementRef) {
    t8 = <div ref={intersectionElementRef} />;
    $[26] = intersectionElementRef;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t6 || $[29] !== t7 || $[30] !== t8) {
    t9 = <div className="tw-space-y-3">{t6}{t7}{t8}</div>;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
};